import { AloftPrice, MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSHoaInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="HOA">
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.AssociationYN} label="Property in HOA" />
      <MLSDataValueWithLabel value={listingData.AssociationName} label="Project" />
    </MLSDataColumn>
    <MLSDataColumn>
      <MLSDataValueWithLabel
        value={
          listingData.AssociationFee
            ? AloftPrice.fromNumericPrice(listingData.AssociationFee ?? 0).toString(true)
            : undefined
        }
        label="Homeowners Dues"
      />
      <MLSDataValueWithLabel value={listingData.AssociationFeeFrequency} label="Frequency" />
      {/* <MlsDataValueWithLabel value={listingData.hoa_phone} label="Phone" />
            <MlsDataValueWithLabel value={listingData.is_adult_community} label="Adult Community" /> */}
    </MLSDataColumn>
  </MLSDataInfoSection>
);
